import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  state: {
    externalId: null,
    planId: null,
    email: null
  },
  mutations: {
    setEmail(state, email) {
      state.email = email
    },
    setExternalId(state, externalId) {
      state.externalId = externalId
    },
    setPlanId(state, planId) {
      state.planId = planId
    },
    setLogin(state, login) {
      state.login = login
    }
  },
  actions: {
    setEmail({ commit }, email) {
      commit('setEmail', email)
    },
    setExternalId({ commit }, externalId) {
      commit('setExternalId', externalId)
    },
    setPlanId({ commit }, planId) {
      commit('setPlanId', planId)
    },
    setLogin({ commit }, login) {
      commit('setLogin', login)
    }
  }
})
